import { API_BASE_URL } from "../config";
import React, { createContext, useState, useEffect } from "react";
import axios from "axios";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem("token") || "");
  const [wallet, setWallet] = useState(null);
  const [loading, setLoading] = useState(true);

  // Set default auth header for axios
  if (token) {
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    delete axios.defaults.headers.common["Authorization"];
  }

  const fetchProfile = async () => {
    if (!token) {
      setLoading(false);
      return;
    }
    try {
      const res = await axios.get(`${API_BASE_URL}/api/auth/me`);
      setUser(res.data.user);
      setWallet(res.data.wallet);
    } catch (err) {
      console.error("Failed to fetch user profile", err);
      logout();
    } finally {
      setLoading(false);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    fetchProfile();
  }, [token]);

  const login = (newToken, userData) => {
    localStorage.setItem("token", newToken);
    setToken(newToken);
    setUser(userData);
    axios.defaults.headers.common["Authorization"] = `Bearer ${newToken}`;
  };

  const logout = () => {
    localStorage.removeItem("token");
    setToken("");
    setUser(null);
    setWallet(null);
    delete axios.defaults.headers.common["Authorization"];
  };

  const refreshWallet = async () => {
    if (!token) return;
    try {
      const res = await axios.get(`${API_BASE_URL}/api/client/wallet`);
      setWallet(res.data.wallet);
    } catch (err) {
      console.error("Error refreshing wallet", err);
    }
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        token,
        wallet,
        loading,
        login,
        logout,
        fetchProfile,
        refreshWallet,
        isAdmin: user?.role === "admin",
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
